import { find, get } from 'lodash';
import { useMemo } from 'react';
import { useQuery } from 'react-apollo';
import query from '../organisationGroupSelectorQuery.graphql';
export default function useOrganisationGroupName(orgGroupId) {
    const queryRes = useQuery(query, {
        fetchPolicy: 'cache-first',
    });
    const models = useMemo(() => get(queryRes, `data.organisationGroupSelector`, []), [queryRes]);
    return useMemo(() => {
        const { name } = find(models, { id: orgGroupId }) || {};
        return name || '';
    }, [models, orgGroupId]);
}
